var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"logo-list"},_vm._l((_vm.logoList),function(item,index){return _c('li',{key:index,staticClass:"logo-item"},[_c('a',{attrs:{"href":item.url}},[_c('img',{attrs:{"src":item.imageUrl,"alt":"赞助商"}})])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }